<template>
  <div class="d-flex-column justify-start align-start gap-5">
    <div class="d-flex-row justify-start gap-5">
      <label for="" class="t-light regular-l font-family-2">{{
        $t(`${title}`)
      }}</label>
      <ItemTooltip :text="$t(tooltip)" />
    </div>
    <DropDown
      :placeholder="$t('calculators_common.desired_rank')"
      :drop-items="getKeyedRanks"
      :select-drop-item="selectDesiredRank"
      :selected-item="checkoutStore.getDetails?.[itemKey]?.id"
      v-if="!$isMobile() && !$isTablet()"
    />
    <BottomSheetPicker
      v-else-if="$isMobile() || $isTablet()"
      :title="$t('calculators_common.desired_rank')"
      :show-title="false"
      :items="getKeyedRanks"
      item-key="id"
      :selected-item="checkoutStore.getDetails?.[itemKey]?.id"
      :select-filter="selectDesiredRank"
      :allow-null="false"
    />
  </div>
</template>

<script setup>
import DropDown from "~/components/custom/DropDown.vue";
import ItemTooltip from "./ItemTooltip.vue";
import BottomSheetPicker from "~/components/common/BottomSheetPicker.vue";

const props = defineProps({
  title: {
    default: "new.difficulty",
  },
  itemKey: {
    default: "desiredRank",
  },
  tooltip: {
    default: "fc-boost.descriptions.desire_rank",
  },
});

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const getKeyedRanks = computed(() => {
  return gameStore.getGameRanks?.reduce((accumulator, value) => {
    return {
      ...accumulator,
      [value.id]: value.title,
    };
  }, {});
});
const selectDesiredRank = (key, value) => {
  const title = getKeyedRanks.value[value];
  checkoutStore.setDetails({
    ...checkoutStore.getDetails,
    [props.itemKey]: {
      title: title,
      id: parseInt(value),
    },
  });
};
</script>
